import { useEffect } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { useLanguage, SUPPORTED_LANGUAGES } from "@/contexts/LanguageContext";

export default function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>();
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      if (lang !== language) {
        setLanguage(lang);
      }
    }
  }, [lang, language, setLanguage]);

  // If lang param is invalid, redirect to current language
  useEffect(() => {
    if (lang && !SUPPORTED_LANGUAGES.includes(lang)) {
      const rest = location.pathname.replace(`/${lang}`, "") || "/";
      navigate(`/${language}${rest === "/" ? "" : rest}${location.search}${location.hash}`, { replace: true });
    }
  }, [lang, language, navigate, location]);

  return <Outlet />;
}
